import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

function ErrorButton(props: any) {
  return (
    <>
      <Box sx={{ "& button": { m: 1 } }}>
        <Button variant="contained" size="small" onClick={() => {
          props.setOpen(!props.open) 
          props.setIndex(props.index)
        }}>
          Detalhes
        </Button>
      </Box>
    </>
  );
}

export default ErrorButton;
